import { IconProps } from '@/components/icons/types'
import { IconBg, iconBgVariants } from '@/components/ui/IconBg'
import { cn } from '@/lib/utils'
import type { VariantProps } from 'class-variance-authority'

type IconBgVariant = VariantProps<typeof iconBgVariants>['variant']

export function TimeLineItem({ children }: { children: React.ReactNode }) {
  return <div className="relative pb-8 pl-10 last:pb-0">{children}</div>
}

export function TimelineItemIcon({
  Icon,
  variant,
  className,
}: {
  Icon: React.FC<IconProps> | null
  variant?: IconBgVariant
  className?: string
}) {
  return (
    <IconBg variant={variant} className={cn('absolute left-px -translate-x-1/2', className)}>
      {Icon ? <Icon size={14} /> : null}
    </IconBg>
  )
}

export function TimelineItemContent({ className, children }: { className?: string; children: React.ReactNode }) {
  return <div className={cn('space-y-3 pt-2 sm:pt-1', className)}>{children}</div>
}
